export const SearchIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19.6709 18.0713L16.0998 14.4855C16.9989 13.3515 17.4898 11.9645 17.4898 10.5233C17.4898 6.91531 14.4533 4 10.7449 4C7.03652 4 4 6.91531 4 10.5233C4 14.1313 7.03652 17.0466 10.7449 17.0466C12.0454 17.0466 13.291 16.6927 14.3761 16.0179L17.9988 19.6554C18.2209 19.8782 18.5196 20 18.8348 20C19.1334 20 19.4199 19.8898 19.6386 19.6867C20.107 19.2515 20.1226 18.5249 19.6709 18.0713ZM10.7449 6.27349C13.1893 6.27349 15.1585 8.19098 15.1585 10.5233C15.1585 12.8556 13.1893 14.7731 10.7449 14.7731C8.3005 14.7731 6.33131 12.8556 6.33131 10.5233C6.33131 8.19098 8.3005 6.27349 10.7449 6.27349Z"
				fill="white"
			/>
		</svg>
	)
}
